module.exports = __webpack_public_path__ + "static/media/awesome-cards.3c80543c.png";